import React, { FC } from 'react';

import { InfoPopover } from '@adsk/alloy-react-tooltip';

import AttachmentsDropzoneLimitations from './AttachmentsDropzoneLimitations';

type AttachmentsDropzoneLimitationPopoverProps = {
  maxSize?: number;
  allowedFileTypes?: string;
};

const AttachmentsDropzoneLimitationPopover: FC<
  AttachmentsDropzoneLimitationPopoverProps
> = ({ maxSize, allowedFileTypes }) => (
  <InfoPopover
    style={{ height: 16, marginLeft: 2 }}
    variant={InfoPopover.VARIANTS.DARK}
    triggerTarget="children"
    message={
      <AttachmentsDropzoneLimitations
        maxSize={maxSize}
        allowedFileTypes={allowedFileTypes}
      />
    }
  />
);

export default AttachmentsDropzoneLimitationPopover;
